import React from "react";

import "./stylesEmailNotificationForm.css";
import HTMLImage from "../../../../../assets/images/html.png";

import { PlusOutlined } from "@ant-design/icons";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

function EmailNotificationForm() {
  return (
    <div className="formSection email-notification">
      <div className="email-notification-header">
        <h2>{AppStrings.EMAIL_VARIANTS}</h2>
        <button>{AppStrings.SAVE_AS_TEMPLATE}</button>
      </div>
      <div className="email-variants">
        <div className="email-variant">
          <div>{AppStrings.VARIANT_1}</div>
        </div>
        <div className="email-variant add-new">
          <div>
            <PlusOutlined className="add-icon" />
            <span>{AppStrings.ADD_NEW}</span>
          </div>
        </div>
      </div>
      <div className="editing-experience">
        <div className="editing-experience-left-content">
          <h3>{AppStrings.SELECT_YOUR_EDITING_EXPERIENCE}</h3>
          <span>{AppStrings.CREATE_YOUR_IDEAL_EMAIL_WITH_OUR_HTML_EDITOR}</span>
        </div>
        <div className="editing-experience-right-content">
          <img src={HTMLImage} alt="HTML Editor" />
          <h3>{AppStrings.HTML_EDITOR}</h3>
          <p>
            {AppStrings.FEATURE_RICH_HTML_EDITING_WITH_VISUAL_PREVIEW}
          </p>
        </div>
      </div>
    </div>
  );
}

export default EmailNotificationForm;
